import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useMemo } from "react";
import { useStringMap } from "../utilities/string-map/useStringMap";
import { useUniqueId } from "../hooks/useUniqueId";
import { MenuListItem } from "../menu-list-item/index";
import { getMenuListItemControlRole } from "../menu-list-item/getMenuListItemControlRole";
import { stringMapDefault } from "../list-box/ListBox.stringMap";
import { MenuListContext } from "./MenuListContext";
import * as Styled from "./MenuList.styled";
import { getMenuListContainerRole } from "./getMenuListContainerRole";
const createListItem = ({ groupItems, isBack, isSeparator, ...item }, { listId, mode, density }, itemIndex) => {
    const key = item.id ? item.id : `i-${itemIndex}`;
    const groupLabelId = `group-label-${key}`;
    const noNestedList = mode !== "navigation" && mode !== "interactive";
    if (isSeparator) {
        return (_jsx(MenuListItem.Separator, { 
            // only add role="separator" if allowed by mode
            role: noNestedList ? "separator" : "", "data-testid": "separator" }, key));
    }
    // TODO: merge back button with common MenuListItem
    const isBackRole = getMenuListItemControlRole({ mode });
    if (isBack) {
        return _jsx(MenuListItem.Back, { density: density, ...item, role: isBackRole }, key);
    }
    // TODO: allow isExpanded=false, still show the label
    if (groupItems !== undefined) {
        return (_jsxs(MenuListItem.Group, { ...item, role: noNestedList ? "group" : "", "aria-labelledby": item.label && noNestedList ? groupLabelId : undefined, children: [item.label && (_jsx(MenuListItem.GroupTitle, { role: noNestedList ? "none" : "listitem", children: item.label })), groupItems.map((groupItem, groupItemIndex) => createListItem(groupItem, { listId, mode, density }, groupItemIndex))] }, key));
    }
    return _jsx(MenuListItem, { density: density, ...item }, key);
};
export const MenuList = forwardRef((props, ref) => {
    const { children, density = "comfortable", stringMap: stringMapProp, id, mode = "interactive", items, ...rest } = props;
    const stringMap = useStringMap("ListBox", { stringMapDefault, stringMapProp });
    const listId = useUniqueId("menu", id);
    const listContext = useMemo(() => ({ listId, mode, density }), [listId, mode, density]);
    const { emptyListMessage } = stringMap;
    const role = getMenuListContainerRole({ mode });
    return (_jsx(Styled.MenuList, { "data-testid": "MenuList", ref: ref, ...rest, role: role, children: _jsxs(MenuListContext.Provider, { value: listContext, children: [items && items.length === 0 && children === undefined && (_jsx(MenuListItem.Empty, { children: emptyListMessage })), items && items.map((item, itemIndex) => createListItem(item, listContext, itemIndex)), children] }) }));
});
const defaultStringMap = {
    emptyListMessage: "No Items Available"
};
MenuList.displayName = "MenuList";
MenuList.defaultProps = {
    stringMap: defaultStringMap
};
